import type { ReactNode as Children } from 'react';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface SectionHeaderProps {
    id?: string;
    title: string;
    subtitle?: React.ReactNode;
    isSmall?: boolean;
    headingToolbar?: Children;
    sectionHeaderOffsetDisabled?: boolean;
}

const SectionHeader = (props: SectionHeaderProps): JSX.Element => {
    const {
        title,
        subtitle,
        id,
        isSmall = false,
        headingToolbar,
        sectionHeaderOffsetDisabled,
    } = props;

    return (
        <Box id={id} sx={{ mb: sectionHeaderOffsetDisabled ? 0 : 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Typography
                    variant={isSmall ? 'h5' : 'h4'}
                    sx={{ mb: subtitle ? 1 : 0 }}
                >
                    {title}
                </Typography>
                {headingToolbar && (
                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                        {headingToolbar}
                    </Box>
                )}
            </Box>
            {subtitle && (
                <Typography
                    variant="body1"
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    {subtitle}
                </Typography>
            )}
            {headingToolbar && (
                <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                    <Box sx={{ mt: 2 }}>{headingToolbar}</Box>
                </Box>
            )}
        </Box>
    );
};

export default SectionHeader;
